import { render, staticRenderFns } from "./PLC.vue?vue&type=template&id=38a9a92f&scoped=true&"
import script from "./PLC.vue?vue&type=script&lang=js&"
export * from "./PLC.vue?vue&type=script&lang=js&"
import style0 from "./PLC.vue?vue&type=style&index=0&id=38a9a92f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a9a92f",
  null
  
)

export default component.exports